module.exports = __webpack_public_path__ + "static/VillageMedia_Prezentacio-001e3d6fb238a1d5a420c9207d3bbd4a.pdf";